/**
 * Created by eriksundqvist on 08/11/16.
 */

class CalculatorPostEntity {

  constructor (
    amount,
    vat,
    rot,
    rut,
    workers,
    expenses
  ) {
    this.amount = amount;
    this.vat = vat;
    this.rot = rot;
    this.rut = rut;
    this.workers = workers;
    this.expenses = expenses;
  }
}

export default CalculatorPostEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/calculator/calculator-post-entity.js
 **/